(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bar-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    const registryKey = '__springMulberryBarMotionPreview';
    if (window[registryKey]) {
      window[registryKey].mount(document);
      return;
    }

    const controllers = new Map();
    const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');

    function mount(scope) {
      const roots = Array.from(scope.querySelectorAll('[data-bar-motion-root]'));
      if (scope.matches && scope.matches('[data-bar-motion-root]')) roots.unshift(scope);

      roots.forEach((root) => {
        if (controllers.has(root)) return;
        const grid = root.querySelector('[data-bar-motion-grid]');
        const cards = root.querySelectorAll('[data-bar-motion-card]');
        if (!grid || !cards.length) return;

        let observer;
        let timer;

        const motionAllowed = () => !motionPreference.matches;
        const viewportHeight = () => document.documentElement.clientHeight || window.innerHeight;

        function stop() {
          if (observer) observer.disconnect();
          observer = undefined;
          window.clearTimeout(timer);
        }

        function settle(state = 'settled', reason = state) {
          stop();
          root.dataset.barMotionState = state;
          root.dataset.barMotionFinishedBy = reason;
        }

        function enter() {
          if (document.activeElement && root.contains(document.activeElement) && (document.activeElement.closest('[data-bar-motion-card]') || document.activeElement.querySelector('[data-bar-motion-card]'))) {
            settle('settled', 'focus');
            return;
          }
          if (!motionAllowed()) {
            settle('static');
            return;
          }
          if (grid.getBoundingClientRect().top < viewportHeight() * 0.5) {
            settle();
            return;
          }
          if (observer) observer.disconnect();
          observer = undefined;
          delete root.dataset.barMotionFinishedBy;
          root.dataset.barMotionState = 'running';
          timer = window.setTimeout(() => settle('settled', 'fallback'), Math.max(5000, 500 + (cards.length - 1) * 120 + 3000));
        }

        function watch() {
          if (observer) observer.disconnect();
          observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) enter();
          }, { rootMargin: '0px', threshold: 0 });
          observer.observe(grid);
        }

        function prepare() {
          settle();
          if (!motionAllowed() || !('IntersectionObserver' in window)) {
            settle('static');
            return;
          }
          if (grid.getBoundingClientRect().top <= viewportHeight()) return;
          root.dataset.barMotionState = 'armed';
          watch();
        }

        function resize() {
          if (root.dataset.barMotionState !== 'armed') return;
          if (grid.getBoundingClientRect().top <= viewportHeight()) enter();
          else watch();
        }

        function focus(event) {
          if (event.target.closest('[data-bar-motion-card]') || event.target.querySelector('[data-bar-motion-card]')) settle('settled', 'focus');
        }

        function finishTransition(event) {
          if (event.propertyName !== 'transform' || !event.target.matches('[data-bar-motion-card]')) return;
          if (event.target === cards[cards.length - 1] && root.dataset.barMotionState === 'running') settle('settled', 'transitionend');
        }

        function preferenceChanged() {
          if (!motionAllowed()) settle('static');
          else if (root.dataset.barMotionState === 'static') prepare();
        }

        root.addEventListener('focusin', focus);
        root.addEventListener('transitionend', finishTransition);
        window.addEventListener('resize', resize, { passive: true });
        motionPreference.addEventListener('change', preferenceChanged);
        prepare();

        controllers.set(root, {
          prepare,
          destroy() {
            settle();
            root.removeEventListener('focusin', focus);
            root.removeEventListener('transitionend', finishTransition);
            window.removeEventListener('resize', resize);
            motionPreference.removeEventListener('change', preferenceChanged);
            controllers.delete(root);
          }
        });
      });
    }

    window[registryKey] = { mount };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
    else mount(document);
    document.addEventListener('shopify:section:load', (event) => mount(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      controllers.forEach((controller, root) => {
        if (event.target === root || event.target.contains(root)) controller.destroy();
      });
    });
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) controllers.forEach((controller) => controller.prepare());
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
